/**
 * Core Utils exports
 */
export { storage } from './storage';
